import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.TipsResult.title',
    defaultMessage: 'Thank you for your tips',
    description: '备注: 页面title'
  },
  ThankYouForYourTips:{
    id:'components.TipsResult.ThankYouForYourTips',
    defaultMessage:'Thank you for your tips',
    description:'Change Me'
  },
  ThankYouForYourTipsDescription:{
    id:'components.TipsResult.ThankYouForYourTipsDescription',
    defaultMessage:'Your support means the world to us and inspires us to continue providing exceptional service.',
    description:'Change Me'
  },
  ViewDetail:{
    id:'components.TipsResult.ViewDetail',
    defaultMessage:'View details',
    description:'Change Me'
  }
})
